import React from "react";
import { List, Avatar, Typography } from "antd";
import './ArtistsList.css';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const { Text , Title} = Typography;


const ArtistList = ({ artists, artistId,setSeeAll }) => {
    const navigate = useNavigate();
    const { translations, language } = useSelector((state) => state.language);

    const navigateToArtist = (artist) => {
        if (artist.username === artistId) {
            setSeeAll(false);
            window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
            setSeeAll(false);
            navigate(`/artists/${artist.username}`);
        }
    };
    return (
        <div className="artist-list-container">
            {/* <div className="artist-list"> */}
            <Title level={3} className="profile-name">{translations.artist.listTitle}</Title>
            {artists.map((artist, index) => (
                <div className="artist-item" key={index} onClick={() => navigateToArtist(artist)}>
                    <div>
                        <Avatar size={60} src={artist.personalPicUrl} className="artist-avatar" />
                    </div>
                    <div className="artist-info">
                        <Text strong>{artist.name}</Text>
                        <Text type="secondary">{artist.username}</Text>
                        <Text>{artist.genre}</Text>
                        <Text type="secondary">{artist.email}</Text>
                    </div>
                </div>
            ))}
            {/* </div> */}
        </div>
    );
};

export default ArtistList;
